import StoreFileService from './store-file-service'

const baseUrl = '/api/customer/media-vault'

export default {
    list: (opt) => {
        opt = {
            album_id: null,
            page: null,
            page_size: null,
            ...opt,
        }

        const qs = Object.keys(opt).filter(k => opt[k]).map(k => `${k}=${encodeURIComponent(opt[k])}`).join('&')

        return axios.get(`${baseUrl}${qs ? `?${qs}` : ''}`)
    },

    store: (opts) => {
        return StoreFileService.store(opts, baseUrl)
    },

    assign: (fileIds, opt) => {
        if (!Array.isArray(fileIds)) {
            fileIds = [fileIds]
        }

        opt = {
            albumId: null,
            ...opt,
        }

        return axios.post(`${baseUrl}/assign`, {
            file_ids: fileIds,
            album_id: opt.albumId,
        })
    },

    delete: (fileId, opt) => {
        opt = {
            albumId: null,
            ...opt,
        }

        return axios.delete(`${baseUrl}`, {
            data: {
                file_id: fileId,
                album_id: opt.albumId,
            },
        })
    },

    listAlbums: () => {
        return axios.get(`${baseUrl}/albums`)
    },

    createAlbum: (opt) => {
        opt = {
            name: null,
            ...opt,
        }

        return axios.post(`${baseUrl}/albums`, opt)
    },
    
    updateAlbum: (id, opt) => {
        opt = {
            name: null,
            ...opt,
        }

        return axios.put(`${baseUrl}/albums/${id}`, opt)
    },

    deleteAlbum: (albumId) => {
        return axios.delete(`${baseUrl}/albums/${albumId}`)
    },

    toPostFiles: (fileIds) => {
        return axios.post(`${baseUrl}/to-post-files`, {
            file_ids: fileIds,
        })
    },
}
